import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'borewell-drilling';
// Fixed slots: img[0]=intro right, img[1]=full strip, img[2]=timeline accent, img[3]=features strip
// Additional: img[4+]

const BorewellDrilling = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="bd-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        {/* Intro: text left, img[0] right only if uploaded */}
        {imgs[0] ? (
          <div className="bd-intro">
            <div className="bd-intro-text">
              <h2>What is {data.title}?</h2>
              <p>{data.intro}</p>
              <p>{data.intro2}</p>
            </div>
            <div className="bd-intro-img">
              <img src={imgs[0].url} alt={imgs[0].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="bd-intro-text-only">
            <h2>What is {data.title}?</h2>
            <p>{data.intro}</p>
            <p>{data.intro2}</p>
          </div>
        )}

        {/* img[1]: full-width strip — only if uploaded */}
        {imgs[1] && (
          <div className="bd-strip-img">
            <img src={imgs[1].url} alt={imgs[1].caption || data.title} />
          </div>
        )}

        {/* Timeline — always show; img[2] accent only if uploaded */}
        {data.processSteps && data.processSteps.length > 0 && (
          imgs[2] ? (
            <div className="bd-timeline-wrap">
              <div className="bd-timeline">
                <h2>{data.processTitle}</h2>
                <div className="bd-tl-list">
                  {data.processSteps.map((s) => (
                    <div className="bd-tl-item" key={s.step}>
                      <div className="bd-tl-dot">{s.step}</div>
                      <div className="bd-tl-content">
                        <strong>{s.title}</strong>
                        <span>{s.desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bd-timeline-accent">
                <img src={imgs[2].url} alt={imgs[2].caption || data.title} />
              </div>
            </div>
          ) : (
            <div className="bd-timeline-solo">
              <h2>{data.processTitle}</h2>
              <div className="bd-tl-list">
                {data.processSteps.map((s) => (
                  <div className="bd-tl-item" key={s.step}>
                    <div className="bd-tl-dot">{s.step}</div>
                    <div className="bd-tl-content">
                      <strong>{s.title}</strong>
                      <span>{s.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        )}

        {/* Features — img[3] strip only if uploaded */}
        {data.features && data.features.length > 0 && (
          <>
            {imgs[3] && (
              <div className="bd-feat-strip">
                <img src={imgs[3].url} alt={imgs[3].caption || data.title} />
              </div>
            )}
            <div className="bd-features">
              <h2>{data.featuresTitle}</h2>
              <div className="bd-feat-grid">
                {data.features.map((f) => (
                  <div className="bd-feat-card" key={f.title}>
                    <div className="bd-feat-icon">{f.icon}</div>
                    <h4>{f.title}</h4>
                    <p>{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="bd-specs">
            <h2>{data.specsTitle}</h2>
            <table className="bd-specs-table">
              <tbody>
                {data.specs.map((row, i) => (
                  <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {imgs.length > 4 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(4).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default BorewellDrilling;
